import React, { useEffect, useState } from 'react';
import { ContentContext } from '../context/ContentContext';
import { getSiteCoreContent } from '../services/sitecoreServices';
import { getCookie } from '../util/cookies';

export const ContentProvider = ({ children }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const checkCookie = () => {
      const cookie = getCookie('lastpassConsentDecision');
      if (cookie) {
        setTimeout(() => {
          getContent();
        }, 500);
      } else {
        setTimeout(() => {
          checkCookie();
        }, 500);
      }
    };

    checkCookie();

    return () => {};
  }, []);

  const getContent = () => {
    getSiteCoreContent()
      .then((result) => {
        if (result.status !== 200) {
          setData(false);
        }
        setData(result.data);
      })
      .catch((error) => {
        if (error.request) {
          setData(false);
        }
      });
  };

  return <ContentContext.Provider value={data}>{children}</ContentContext.Provider>;
};
